"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const api_1 = require("../api");
const adapter_1 = require("../api/adapter");
const errors_1 = require("./errors");
const context_1 = require("./utils/context/context");
const event_emitter_1 = require("./utils/events/event-emitter");
const common_1 = require("../utils/common");
const auth_core_1 = tslib_1.__importDefault(require("./utils/auth/auth-core"));
const request_1 = tslib_1.__importDefault(require("./utils/request/request"));
const MEOW_SUPPORTED_AUDIO_CODECS = ["aac"];
var UrlParams;
(function (UrlParams) {
    UrlParams["SBP"] = "sbp";
    UrlParams["IMG"] = "img";
    UrlParams["VDC"] = "vdc";
    UrlParams["SUBSTITUTE"] = "substitute";
})(UrlParams || (UrlParams = {}));
/**
 * Interacts with the api to fetch video data
 */
class MediaLoader extends event_emitter_1.ObservableEventEmitter {
    /**
     * Creates MediaLoader for loading manifest by url.
     * Or creates MediaLoader with already loaded manifest
     */
    constructor(ctx, manifest, options) {
        super();
        this.source = null;
        this.currentState = "offline";
        this.formats = {};
        this.uri = null;
        this.originalAuthToken = null;
        this.viewCount = 0;
        this.pingUri = null;
        this.destroyed = false;
        this.shouldBePolling = false;
        this.manifest = null;
        this.type = null;
        this.pollingTimeout = null;
        this.noLongerUnauthorizedPolling = false;
        this.unauthorizedRecoveryTimout = null;
        this.ctx = ctx;
        (0, context_1.onceCanceled)(ctx).then((reason) => this.dispose(`MediaLoader Class Context Closed: ${reason}`));
        (0, mobx_1.makeObservable)(this, {
            source: mobx_1.observable.ref,
        });
        this.currentState = "offline";
        this.formats = {};
        this.pingUri = null;
        this.destroyed = false;
        this.options = options;
        this.setManifest(manifest);
        this.setUri(manifest);
        this.shouldBePolling = false;
        ctx.logger.attachObject(this);
        if (this.ctx.token != null) {
            const bootstrap = typeof this.ctx.token === "string" ? { token: this.ctx.token } : { refreshToken: this.ctx.token };
            // should this Auth handle w/ endpoints as well? Where should that be configured?
            this.auth = new auth_core_1.default({
                bootstrap,
            });
        }
        ctx.logger.trace("constructor()", {
            manifest,
            auth: {
                token: this.ctx.token === "string" ? this.ctx.token : undefined,
                hasRefreshToken: !!(this.ctx.token != null && this.ctx.token !== "string"),
            },
        });
        this.addInnerDisposer(() => {
            var _a;
            if (this.auth != null) {
                this.auth.destroy();
            }
            this.destroyed = true;
            clearInterval((_a = this.pollingTimeout) !== null && _a !== void 0 ? _a : 0);
        });
    }
    static modifyFormats(formats) {
        for (const formatName of Object.keys(formats)) {
            if (formatName === "mp4-ws") {
                const format = formats[formatName];
                if ((format === null || format === void 0 ? void 0 : format.origin) != null && MEOW_SUPPORTED_AUDIO_CODECS.includes(format.audioCodec)) {
                    format.origin = undefined;
                }
            }
        }
        return formats;
    }
    /**
     * Loads the media data
     *
     * @throws {ErrorCode.ManifestError} if the manifest cannot be loaded
     */
    async load(previewImg = false) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        if (this.manifest != null || this.vod) {
            this.emit("manifest", { state: this.currentState, formats: this.formats });
            if (this.manifest != null && typeof this.manifest !== "string") {
                this.source = this.manifest;
            }
            return;
        }
        if (this.uri == null) {
            return;
        }
        this.ctx.logger.debug("loading manifest", { uri: this.uri });
        let requestResponse = null;
        let code;
        let err = null;
        let json;
        const urlSplit = this.uri.split("?");
        let newParams;
        newParams = urlSplit[1] ? `&${urlSplit[1]}` : "";
        newParams = (0, common_1.removeSearchParameterFromUrl)(newParams, UrlParams.IMG);
        newParams = `${newParams}&${UrlParams.IMG}=${previewImg.toString()}`;
        newParams = (0, common_1.removeSearchParameterFromUrl)(newParams, UrlParams.VDC);
        // Used to help the backend identify that Video Client V2 is in usage.
        if (((_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.urlParams) === null || _b === void 0 ? void 0 : _b.vdc) != null ? (_d = (_c = this.options) === null || _c === void 0 ? void 0 : _c.urlParams) === null || _d === void 0 ? void 0 : _d.vdc : true) {
            newParams = `${newParams}&${UrlParams.VDC}=true`;
        }
        //bp=true: auth’s streams will return as “blur” when viewer doesn’t have
        // a valid access token (un-auth’s streams are un-changed)
        newParams = (0, common_1.removeSearchParameterFromUrl)(newParams, UrlParams.SBP);
        if (((_f = (_e = this.options) === null || _e === void 0 ? void 0 : _e.urlParams) === null || _f === void 0 ? void 0 : _f.sbp) != null ? (_h = (_g = this.options) === null || _g === void 0 ? void 0 : _g.urlParams) === null || _h === void 0 ? void 0 : _h.sbp : true) {
            newParams = `${newParams}&${UrlParams.SBP}=true`;
        }
        // substitute=true: un-auth’d streams will return as “blur” (auth’d stream will
        // remain the same, if the user has no access token, then will 403, if they do they will play normally)
        newParams = (0, common_1.removeSearchParameterFromUrl)(newParams, UrlParams.SUBSTITUTE);
        // Used to tell the backend to provide a substitute stream or not in order to control the blur feature
        if (((_k = (_j = this.options) === null || _j === void 0 ? void 0 : _j.urlParams) === null || _k === void 0 ? void 0 : _k.substitute) != null ? (_m = (_l = this.options) === null || _l === void 0 ? void 0 : _l.urlParams) === null || _m === void 0 ? void 0 : _m.substitute : true) {
            newParams = `${newParams}&${UrlParams.SUBSTITUTE}=true`;
        }
        const newUrl = `${urlSplit[0]}?${newParams}`;
        try {
            requestResponse = await (0, request_1.default)(this.ctx, newUrl, {
                auth: this.auth,
                method: "get",
                headers: this.options.requestHeaders,
            });
            code = (_o = requestResponse === null || requestResponse === void 0 ? void 0 : requestResponse.status) !== null && _o !== void 0 ? _o : 0;
        }
        catch (ex) {
            code = (_p = requestResponse === null || requestResponse === void 0 ? void 0 : requestResponse.status) !== null && _p !== void 0 ? _p : 0;
            err = (0, errors_1.createError)(api_1.ErrorCode.NetworkError, "Internal Error", { status: code });
        }
        if (this.isDisposed) {
            return;
        }
        if (code > 499) {
            err = (0, errors_1.createError)(api_1.ErrorCode.NetworkError, "Internal Error", { status: code });
        }
        else if (code === 404) {
            err = (0, errors_1.createError)(api_1.ErrorCode.NetworkError, "Not Found", { status: code });
        }
        else if (code === 403) {
            err = (0, errors_1.createError)(api_1.ErrorCode.NetworkError, "Forbidden", { status: code });
        }
        else if (code === 401) {
            err = (0, errors_1.createError)(api_1.ErrorCode.NetworkError, "Unauthorized", { status: code });
        }
        let body = null;
        if (!err && (requestResponse === null || requestResponse === void 0 ? void 0 : requestResponse.body) != null) {
            body = this.validateResponse(requestResponse === null || requestResponse === void 0 ? void 0 : requestResponse.body) ? requestResponse === null || requestResponse === void 0 ? void 0 : requestResponse.body : null;
        }
        if (!err && body == null) {
            err = (0, errors_1.createError)(api_1.ErrorCode.NetworkError, "Unexpected Response", { status: code });
        }
        if (err != null) {
            if (code === 404) {
                this.ctx.logger.debug("manifest not found");
            }
            else {
                this.emitError(err);
            }
        }
        this.ctx.logger.debug("manifest received", {
            body,
            code,
            uri: this.uri,
        });
        let state = null;
        if (code === 404 || body == null || body.formats == null) {
            state = "offline";
        }
        else if (code === 200 && body.self != null) {
            // todo: probably that's a bug on server side and should be fixed
            // there instead of using this workaround
            let { self } = body;
            if (!self.includes("://") && this.uri.includes("://")) {
                const path = /(\w*:\/\/[^/]+)/.exec(this.uri);
                if (((_q = path === null || path === void 0 ? void 0 : path.length) !== null && _q !== void 0 ? _q : 0) > 1) {
                    self = `${path === null || path === void 0 ? void 0 : path[1]}/${self}`;
                }
            }
            this.uri = self;
        }
        if (state == null && (body === null || body === void 0 ? void 0 : body.formats) != null) {
            this.formats = MediaLoader.modifyFormats(body.formats);
            state = Object.keys(this.formats).length === 0 ? "offline" : "online";
        }
        if (state === "online" && (body === null || body === void 0 ? void 0 : body.viewCount) != null) {
            this.viewCount = body.viewCount;
        }
        if (state == null) {
            const msg = code >= 400 ? "Network error while retrieving manifest" : "Invalid manifest";
            this.throwError((0, errors_1.createError)(api_1.ErrorCode.ManifestError, msg, { url: this.uri }, err));
        }
        if (state !== this.currentState) {
            this.emit(state);
        }
        this.currentState = state;
        this.pingUri = (body === null || body === void 0 ? void 0 : body.ping) != null ? body.ping : null;
        this.type = (body === null || body === void 0 ? void 0 : body.type) != null ? body.type : "live";
        this.emit("manifest", { state: this.currentState, code, formats: this.formats, viewCount: this.viewCount });
        if (body != null) {
            this.source = body;
        }
        if ((body === null || body === void 0 ? void 0 : body.type) !== "recorded") {
            this.setNextPoll(code);
        }
    }
    setNextPoll(statusCode) {
        var _a;
        if (this.vod) {
            return;
        }
        adapter_1.device.clearTimeout((_a = this.pollingTimeout) !== null && _a !== void 0 ? _a : 0);
        let to = this.options.pollingInterval;
        switch (statusCode) {
            case 401:
            case 403:
                if (this.noLongerUnauthorizedPolling) {
                    this.currentState = "forbidden";
                    this.emit("manifest", { state: this.currentState, code: statusCode, formats: this.formats });
                    return;
                }
                to = this.options.unauthorizedPollingInterval;
                if (this.unauthorizedRecoveryTimout == null) {
                    this.unauthorizedRecoveryTimout = adapter_1.device.setTimeout(() => {
                        this.noLongerUnauthorizedPolling = true;
                    }, this.options.unauthorizedRecoveryDuration);
                }
                break;
            case 404:
                to = this.options.notFoundPollingInterval;
                break;
            default:
                this.noLongerUnauthorizedPolling = false;
        }
        this.pollingTimeout = adapter_1.device.setTimeout(() => {
            this.load().catch((ex) => this.emit("error", ex));
        }, to);
    }
    /**
     * Sets the manifest
     */
    setManifest(manifest) {
        var _a, _b, _c, _d;
        this.type = null;
        this.formats = {};
        if (typeof manifest === "string") {
            this.uri = manifest;
        }
        else if (this.validateResponse(manifest)) {
            this.uri = (_a = manifest.self) !== null && _a !== void 0 ? _a : null;
            this.manifest = manifest;
            this.currentState = "online";
            this.type = (_b = this.manifest.type) !== null && _b !== void 0 ? _b : null;
            this.formats = (_c = this.manifest.formats) !== null && _c !== void 0 ? _c : {};
        }
        if (this.uri == null) {
            return;
        }
        // parse original auth token from manifest url
        const accessTokenIndex = this.uri.indexOf("accessToken=");
        if (accessTokenIndex > -1) {
            const at = this.uri.slice(accessTokenIndex + 12);
            const qpIndex = (_d = at.indexOf("&")) !== null && _d !== void 0 ? _d : -1;
            if (qpIndex > -1) {
                this.originalAuthToken = at.slice(0, qpIndex);
            }
            else {
                this.originalAuthToken = at;
            }
        }
    }
    get hasPlayableMedia() {
        return this.uri != null || this.manifest != null;
    }
    validateResponse(body) {
        var _a, _b, _c;
        try {
            const manifestBody = body;
            // TODO: that's a bug on server-side. remove it when it's fixed
            const webrtc = (_a = manifestBody.formats) === null || _a === void 0 ? void 0 : _a.webrtc;
            if (webrtc != null) {
                if (typeof ((_b = webrtc.origin) === null || _b === void 0 ? void 0 : _b.location) === "string") {
                    webrtc.origin.location = (_c = webrtc.origin) === null || _c === void 0 ? void 0 : _c.location.replace(/https?:\/\/(https?):?\/\//, "$1://");
                }
                if (typeof webrtc.origin.rsrc === "string") {
                    webrtc.origin.rsrc = webrtc.origin.rsrc.replace(/:3000:3000/, ":3000");
                }
            }
        }
        catch (ex) {
            this.emitError((0, errors_1.createError)(api_1.ErrorCode.BadManifest, "bad manifest", {}, ex));
            return false;
        }
        return true;
    }
    setUri(manifest) {
        if (manifest == null) {
            return this.uri != null;
        }
        if (typeof manifest === "string") {
            this.uri = manifest;
            return true;
        }
        if (this.validateResponse(manifest)) {
            this.manifest = manifest;
            if (manifest.self != null) {
                this.uri = manifest.self;
            }
            return true;
        }
        this.emitError((0, errors_1.createError)(api_1.ErrorCode.BadManifest, "Invalid Media URL", {}));
        return false;
    }
    /**
     * Returns the state and formats
     */
    get(formatName) {
        var _a;
        const format = this.formats[formatName];
        if (format == null) {
            return {
                encodings: [],
                state: "online",
                auto: false,
                driver: "",
            };
        }
        let encodings = [];
        let origin;
        if ("origin" in format && format.origin != null) {
            origin = format.origin;
            origin.origin = true;
        }
        if ("encodings" in format && format.encodings != null) {
            encodings = format.encodings.sort((a, b) => {
                var _a, _b, _c, _d;
                if (((_a = a.videoKbps) !== null && _a !== void 0 ? _a : 0) + ((_b = a.audioKbps) !== null && _b !== void 0 ? _b : 0) > ((_c = b.videoKbps) !== null && _c !== void 0 ? _c : 0) + ((_d = b.audioKbps) !== null && _d !== void 0 ? _d : 0)) {
                    return 1;
                }
                return -1;
            });
        }
        return {
            type: (_a = this.type) !== null && _a !== void 0 ? _a : undefined,
            origin: origin !== null && origin !== void 0 ? origin : undefined,
            encodings,
            audioCodec: "audioCodec" in format ? format.audioCodec : undefined,
            videoCodec: "videoCodec" in format ? format.videoCodec : undefined,
            manifest: "manifest" in format ? format.manifest : undefined,
            state: "online",
            auto: false,
            driver: "",
        };
    }
    get vod() {
        return this.type === "recorded";
    }
    /**
     * Starts a polling interval
     */
    startInterval() {
        if (this.options.pollingInterval == null || this.manifest != null || this.vod) {
            this.shouldBePolling = false;
            return;
        }
        this.shouldBePolling = true;
    }
    toJSON() {
        return {
            uri: this.uri,
            options: JSON.stringify(this.options),
            aggregates: {
                support: this.ctx.support.hash,
                state: this.currentState,
            },
        };
    }
}
MediaLoader.displayName = "MediaLoader";
exports.default = MediaLoader;
//# sourceMappingURL=media-loader.js.map